import { useState, useCallback } from "react";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData, errorCallback) => {
    setIsLoading(true);
    setError(null);

    try {
      const isFormData = requestConfig.body instanceof FormData;

      const headers = requestConfig.headers
        ? { ...requestConfig.headers }
        : {};

      headers["authorization"] = `Bearer ${localStorage.getItem("token")}`;

      if (!isFormData) {
        headers["Content-Type"] = "application/json";
        headers["Accept"] = "application/json";
      }

      const body = isFormData
        ? requestConfig.body
        : requestConfig.body
          ? JSON.stringify(requestConfig.body)
          : null;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${requestConfig.url}`,
        {
          method: requestConfig.method ? requestConfig.method : "GET",
          headers,
          body,
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data);
      }

      const data = await response.json();
      applyData(data);
    } catch (err) {
      setError(err.message || "Something went wrong!");
      if (errorCallback) {

        errorCallback(err.message || "Something went wrong!");
      }
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
